import { createClient } from 'graphql-ws';
import { RelayExperimentalApis } from '@atlassian/relay-experimental-apis';
import { WS_CLIENT_KEEP_ALIVE, WS_CLIENT_RETRIES } from '../../constants';
import { getAggSubscriptionEndpoint, isSSR } from '../index';
var client;
export var getClient = function getClient() {
  if (isSSR()) {
    return null;
  }
  if (!client) {
    var _BUILD_KEY, _window, _SSR_BUILD_KEY, _window2;
    client = createClient({
      url: getAggSubscriptionEndpoint(),
      lazy: true,
      keepAlive: WS_CLIENT_KEEP_ALIVE,
      retryAttempts: WS_CLIENT_RETRIES,
      connectionParams: {
        'atl-client-name': 'jira-frontend',
        'atl-client-version': "".concat((_BUILD_KEY = (_window = window) === null || _window === void 0 ? void 0 : _window.BUILD_KEY) !== null && _BUILD_KEY !== void 0 ? _BUILD_KEY : '', "::").concat((_SSR_BUILD_KEY = (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.SSR_BUILD_KEY) !== null && _SSR_BUILD_KEY !== void 0 ? _SSR_BUILD_KEY : ''),
        'X-ExperimentalApi': RelayExperimentalApis.join(',')
      }
    });
  }
  return client;
};
export var cleanUpClient = function cleanUpClient() {
  client = null;
};